import React, { ReactElement, useState } from 'react'
import { DatePicker, HeaderPage, Select } from '@components/atoms'
import { ContainerPesquisa } from '@pages/style'
import { useForm } from 'react-hook-form'
import { Button, Col, Row, Typography, Table, Spin, Drawer } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import { SearchOutlined } from '@ant-design/icons'

const data = [
  {
    ALTERACAO: '1000102',
    DESCPRODUTO: 'Descrição sobre o produto 1',
    UNIDADE: '10',
    PRECOANTIGO: 'R$ 20,00',
    PRECONOVO: 'R$ 35,00',
    PERCALTERACAO: '1,22%',
    MARCA: 'Nike',
    DATA: '22/10/2021',
    USUARIO: 'Augusto Neto',
  },
  {
    ALTERACAO: '2000102',
    DESCPRODUTO: 'Descrição sobre o produto 2',
    UNIDADE: '10',
    PRECOANTIGO: 'R$ 20,00',
    PRECONOVO: 'R$ 35,00',
    PERCALTERACAO: '1,22%',
    MARCA: 'Nike',
    DATA: '22/10/2021',
    USUARIO: 'Augusto Neto',
  },
  {
    ALTERACAO: '3000102',
    DESCPRODUTO: 'Descrição sobre o produto 3',
    UNIDADE: '10',
    PRECOANTIGO: 'R$ 20,00',
    PRECONOVO: 'R$ 35,00',
    PERCALTERACAO: '1,22%',
    MARCA: 'Nike',
    DATA: '22/10/2021',
    USUARIO: 'Augusto Neto',
  },
  {
    ALTERACAO: '4000102',
    DESCPRODUTO: 'Descrição sobre o produto 4',
    UNIDADE: '10',
    PRECOANTIGO: 'R$ 20,00',
    PRECONOVO: 'R$ 35,00',
    PERCALTERACAO: '1,22%',
    MARCA: 'Nike',
    DATA: '22/10/2021',
    USUARIO: 'Augusto Neto',
  },
]

export default function AlteracaoPrecoVenda(): ReactElement {
  const { control, watch, reset } = useForm()
  const { Option } = Select
  // const methods = useForm()
  const allFields = /* methods. */ watch()
  const { Column } = Table
  const [spinning, setSpinning] = useState(false)
  const [visible, setVisible] = useState(false)

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const limparFiltros = () => {
    reset()
  }

  const filtrarResultados = () => {}

  return (
    <ContainerPesquisa>
      <Content style={{ padding: 24 }}>
        <Spin tip='Filtrando...' spinning={spinning}>
          <HeaderPage
            title='Alteração de Preço de Venda'
            extra={[
              <Button
                key='buttonSearch'
                className='buttonSearch'
                onClick={() => showDrawer()}
              >
                <p>Filtrar</p>
                <SearchOutlined key='iconSearch' className='iconSearch' />
              </Button>,
            ]}
          />
          <Table dataSource={data}>
            <Column title='Alteração' dataIndex={'ALTERACAO'} />
            <Column title='Descrição do Produto' dataIndex={'DESCPRODUTO'} />
            <Column title='Und' dataIndex={'UNIDADE'} />
            <Column title='Preço Antigo' dataIndex={'PRECOANTIGO'} />
            <Column title='Preço Novo' dataIndex={'PRECONOVO'} />
            <Column title='% Alteração' dataIndex={'PERCALTERACAO'} />
            <Column title='Marca' dataIndex={'MARCA'} />
            <Column title='Data' dataIndex={'DATA'} />
            <Column title='Usuário' dataIndex={'USUARIO'} />
          </Table>
        </Spin>
      </Content>
      <Drawer
        onClose={onClose}
        visible={visible}
        title='Filtros'
        style={{ marginTop: '4rem' }}
      >
        <Row key='mainRow' gutter={3}>
          <Col span={allFields.PRODUTO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Produto</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='PRODUTO'
              placeholder='Produto'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.PRODUTO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Produto Específica</Typography.Title>
              <Select
                control={control}
                allowClear
                name='PRODUTOESPEC'
                placeholder='Produto Específica'
              >
                <Option value='Produto 1'>Produto 1</Option>
                <Option value='Produto 2'>Produto 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.GRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Grupo</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='GRUPO'
              placeholder='Grupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.GRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Grupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='GRUPOESPEC'
                placeholder='Grupo Específico'
              >
                <Option value='Grupo 1'>Grupo 1</Option>
                <Option value='Grupo 2'>Grupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.SUBGRUPO === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>SubGrupo</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='SUBGRUPO'
              placeholder='SubGrupo'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.SUBGRUPO === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>SubGrupo Específico</Typography.Title>
              <Select
                control={control}
                allowClear
                name='SUBGRUPOESPEC'
                placeholder='SubGrupo Específico'
              >
                <Option value='SubGrupo 1'>SubGrupo 1</Option>
                <Option value='SubGrupo 2'>SubGrupo 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={allFields.MARCA === 'Específico' ? 7 : 24}>
            <Typography.Title level={5}>Marca</Typography.Title>
            <Select
              control={control}
              defaultValue='Todos'
              allowClear
              name='MARCA'
              placeholder='Marca'
            >
              <Option value='Todos'>Todos</Option>
              <Option value='Específico'>Específico</Option>
            </Select>
          </Col>
          {allFields.MARCA === 'Específico' ? (
            <Col span={17}>
              <Typography.Title level={5}>Marca Específica</Typography.Title>
              <Select
                control={control}
                allowClear
                name='MARCAESPEC'
                placeholder='Marca Específica'
              >
                <Option value='Marca 1'>Marca 1</Option>
                <Option value='Marca 2'>Marca 2</Option>
              </Select>
            </Col>
          ) : null}
          <Col span={24}>
            <Typography.Title level={5}>Período da Alteração</Typography.Title>
            <Row gutter={3} align='middle'>
              <Col span={12}>
                <DatePicker name='DTINICIO' control={control} />
              </Col>
              <Col span={12}>
                <DatePicker name='DTFINAL' control={control} />
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Typography.Title level={5}>Última Alteração</Typography.Title>
            <Select
              control={control}
              allowClear
              name='MARCAESPEC'
              placeholder='Última Alteração'
            >
              <Option value='Sim'>Sim</Option>
              <Option value='Todas'>Todas</Option>
            </Select>
          </Col>
          <Col span={24}>
            <Typography.Title level={5}>Selecionar</Typography.Title>
            <Select
              control={control}
              allowClear
              name='SELECIONAR'
              placeholder='Selecionar'
            >
              <Option value='Produto'>Produto</Option>
              <Option value='Serviço'>Serviço</Option>
              <Option value='Ambos'>Ambos</Option>
            </Select>
          </Col>
          <Col span={24} style={{ marginTop: '1.5rem' }}>
            <Row gutter={5}>
              <Col>
                <Button
                  danger
                  type='default'
                  onClick={() => {
                    limparFiltros()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Limpar filtro
                </Button>
              </Col>
              <Col>
                <Button
                  type='primary'
                  onClick={() => {
                    filtrarResultados(/* {
                      descproduto: allFields.AGRUPAMENTO_ESPEC,
                      grupo: allFields.CLIENTE_ESPEC,
                      marca: allFields.DTINICIO,
                      custoaquisicao: allFields.DTFINAL,
                      precovenda: allFields.VALOR,
                    } */)

                    onClose()
                  }}
                  style={{
                    width: 110,
                  }}
                >
                  Filtrar
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Drawer>
    </ContainerPesquisa>
  )
}
